<template>
  <transition name="fade">
    <div class="promptMsg" v-show="showPrompt">{{ msg }}</div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      showPrompt: false,
      msg: ''
    }
  },
  methods: {
    setMsg(msg) {
      this.msg = msg
      this.showPrompt = true
      setTimeout(() => {
        this.showPrompt = false
        this.msg = ''
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.promptMsg {
  width: 150px;
  height: 50px;
  padding: 0 get_vh(30px);
  // min-width: 270px
  // // height: 80px;
  line-height: 50px;
  background-color: rgba(31, 31, 31, 0.8);
  border-radius: get_vh(48px);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  // @include fontSet(24px);
  color: #fff;
  text-align: center;
  z-index: 5;
  font-size: 20px;
}
</style>